const THEME_COLLECTION = [
  { label: "UniQueue", value: "UniQueue" },
  { label: "Red", value: "Kommunal" },
  { label: "Black", value: "Link22" },
  { label: "Blue", value: "Blue" },
  { label: "Orange", value: "Orange" },
  { label: "Custom", value: "custom" },
];


export default THEME_COLLECTION;